import service from '../../services/MeasurementService';
import log from '../../services/LogService';

export const PollingState = {
  UNDEFINED: 'UNDEFINED',
  MEASURING: 'MEASURING',
  DONE: 'DONE',
  CANCELLED: 'CANCELLED',
  TIMEOUT: 'TIMEOT'
};

export interface FrameSet {
  arch_type: string;
}

let pollingState = PollingState.UNDEFINED;


function findArchTypeFrame(frames) {
  return frames.find(item => !!item.arch_type);
}

function checkFrames(frames:Array<FrameSet>) {

  if(pollingState === PollingState.CANCELLED) {
    return pollingState;
  }

  const hasFrames = frames && frames.length;

  if (!hasFrames) {
    return PollingState.MEASURING;
  }

  const minipodFrame = findArchTypeFrame(frames);

  if (minipodFrame) {
    return PollingState.DONE;
  }

  return PollingState.MEASURING;
}

function waitForPollingOutcome(expected, measurementId, sessionId) {

  service.setSessionId(sessionId);
  service.setMeasurementId(measurementId);

  return new Promise((fulfill, reject) => {

    let toId = null;

    const poll = () => {
      console.log('[minipod] polling . . .');
      service.getMeasurementFrames()
      .then(response => {
        const { data } = response;
        const outcome = checkFrames(data);

        log.info('Polling: ', outcome);

          // setPollingState(outcome);
          const isFinalOutcome =
            outcome === PollingState.DONE ||
            outcome === PollingState.CANCELLED ||
            outcome === PollingState.TIMEOUT;

          const continuePolling = !isFinalOutcome;

          if (outcome === expected) {
            log.info('stopped polling');
            clearTimeout(toId);
            const frame = findArchTypeFrame(data);
            fulfill(frame);
          }

          if (continuePolling) {
            console.log('[minipod] waiting for user measurement');
            toId = setTimeout(poll, 1000);
          } else if (outcome === PollingState.DONE) {
            log.info('stopped polling');
            clearTimeout(toId);
            const frame = findArchTypeFrame(data);
            fulfill(frame);
          } else {
            log.info('stopped polling');
            clearTimeout(toId);
            reject(outcome);
          }
        })
        .catch((err) => {
          reject(err);
        });
    }

    log.info('start polling');
    poll();
  });
}

export default {
  poll: (measurementId: string, sessionId: string) => {
    return waitForPollingOutcome(PollingState.DONE, measurementId, sessionId);
  },
  stop: () => { pollingState = PollingState.CANCELLED; }
};
